//Import resources
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; //react-router-dom V6 syntax

//Import components
import Home from "./pages/Home";
import ScanTranslate from "./pages/ScanTranslate";
import MyWords from "./pages/MyWords";
import MyNavbar from "./components/MyNavbar";

const App = () => {
  //RETURN this JSX to UI
  return (
    <Router>
      <div className="container">
        <br />
        <MyNavbar />
        <br />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/scan" element={<ScanTranslate />}></Route>
          <Route path="/my-words" element={<MyWords />}></Route>
        </Routes>
      </div>
    </Router>
  );
};

export default App;
